import { FirearmStorageLocationPLISearchComponentBase } from './firearm-storage-location-pli-search.component.base';
import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { FirearmStorageLocationPLIService, FirearmStorageLocationService } from 'assets-service';


@Component({
  selector: 'app-firearm-storage-location-pli-search',
  templateUrl: './firearm-storage-location-pli-search.component.html',
  styleUrls: ['./firearm-storage-location-pli-search.component.scss']
})
export class FirearmStorageLocationPLISearchComponent extends FirearmStorageLocationPLISearchComponentBase {
  get locationName(): string { return this.route.snapshot.data.storageLocation?.location; }

  displayedColumns = ['validFromDate', 'validToDate', 'hasDocuments',
    'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'actions'];
  disabledColumns = ['comments'];

  createServiceArguments(): any {
    // Only send visible filters: previously remembered, now-hidden filters must
    // not silently restrict results. Location always comes from the parent route.
    return {
      firearmStorageLocationId: Number(this.route.snapshot.paramMap.get('firearmStorageLocationId')),
      createdBy: this.createdByFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      updatedBy: this.updatedByFilter,
      updatedDateGreaterThanOrEqualTo: this.updatedDateGreaterThanOrEqualToFilter,
      updatedDateLessThanOrEqualTo: this.updatedDateLessThanOrEqualToFilter,
      comments: this.commentsFilter,
      hasDocuments: this.hasDocumentsFilter,
      validFromDateGreaterThanOrEqualTo: this.validFromDateGreaterThanOrEqualToFilter,
      validToDateLessThanOrEqualTo: this.validToDateLessThanOrEqualToFilter
    };
  }

  createRoute(): any[] {
    return ['/firearmstoragelocationpli/create', this.route.snapshot.paramMap.get('firearmStorageLocationId')];
  }

  backRoute(): any[] {
    return ['/firearmstoragelocation/view', this.route.snapshot.paramMap.get('firearmStorageLocationId')];
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmStorageLocationPLIService: FirearmStorageLocationPLIService,
    protected firearmStorageLocationService: FirearmStorageLocationService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, firearmStorageLocationPLIService, firearmStorageLocationService, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    const location = this.route.snapshot.data.storageLocation;
    this.firearmStorageLocationSelectionList = location ? [location] : [];
    this.firearmStorageLocationFilter = location;
    this.searchForm.get('firearmStorageLocation').setValue(location, { emitEvent: false });
    this.searchForm.get('firearmStorageLocation').disable({ emitEvent: false });
    
    super.onInitAsyncComplete();
  }
  
  resetSearchForm() {
    // placeholder
  }
  
  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }
  
}



